import { render } from "./MyLucky.vue?vue&type=template&id=17dd1878&bindings={}"
import script from "./MyLucky.vue?vue&type=script&lang=ts"
export * from "./MyLucky.vue?vue&type=script&lang=ts"

import "./MyLucky.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script